export * from '@primeuix/themes/aura/password';
export { default } from '@primeuix/themes/aura/password';
